import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Typography } from '@mui/material';
import { IOSSlider } from './IOSSlider';
import { CommunityFilter } from '../model/CommunityFilter';
import { useChangeAgeRange } from '../hook/useFilterAction';
import {
  MAX_AGE_RANGE_IN_MONTHS,
  MIN_AGE_RANGE_IN_MONTHS,
} from '../hook/useCommunityFilter';

type FilterAgeRangeProps = {
  communityFilter: CommunityFilter;
};

const AGE_RANGE_MARKS = [
  {
    value: MIN_AGE_RANGE_IN_MONTHS,
    label: '0',
  },
  {
    value: MAX_AGE_RANGE_IN_MONTHS,
    label: '18+',
  },
];

export const AgeRangeFilter = ({ communityFilter }: FilterAgeRangeProps) => {
  const intl = useIntl();
  const changeAgeRange = useChangeAgeRange();
  const { ageRangeStartInMonths, ageRangeEndInMonths } = communityFilter;

  return (
    <Box sx={{ py: 5, px: 10 }}>
      <Typography sx={{ fontWeight: 500 }}>
        <FormattedMessage id='community.filter.child-age-range' />
      </Typography>
      <Box sx={{ my: 16 }}>
        <IOSSlider
          getAriaLabel={() => 'Default'}
          value={[ageRangeStartInMonths, ageRangeEndInMonths]}
          onChange={changeAgeRange}
          valueLabelDisplay='on'
          min={MIN_AGE_RANGE_IN_MONTHS}
          max={MAX_AGE_RANGE_IN_MONTHS}
          valueLabelFormat={(value) =>
            intl.formatMessage(
              { id: 'community.filter.year' },
              { age: ageInYear(value) },
            )
          }
          marks={AGE_RANGE_MARKS}
          sx={{
            '& .MuiSlider-mark': {
              display: 'none',
            },
          }}
        />
      </Box>
    </Box>
  );
};

const ageInYear = (ageInMonths: number) => Math.floor(ageInMonths / 12);
